// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./project.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./project.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./project.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/styles/containers/project/unitLayouts/project.less
// module id = 3502
// module chunks = 0